//-----------Components-----------//
import NavBar from "../Details/NavBar.js";

export default function Spare() {
  return (
    <div className=" flex h-screen flex-col items-center justify-center">
      <NavBar label="Spare" />
      <h1>Spare Page</h1>
    </div>
  );
}
